import { Component, OnInit } from '@angular/core';
import {paramsHelper} from "../../helpers/params-helper";
import {DOCUMENT_TYPES} from "../../enums/enums";
import {BusService} from "../../services/bus.service";
import {IDocument} from "../../interfaces/document.definition";

@Component({
  selector: 'app-consts-page',
  templateUrl: './consts-page.component.html',
  styles: []
})
export class ConstsPageComponent implements OnInit {
  pageParams = paramsHelper.page()
    .setDisabledOptionVisible(false)
    .setTitle("Константы");

  collectionParams = paramsHelper.collection()
    .setDuplicateEnabled(false)
    .setObjectType(DOCUMENT_TYPES.CONSTS)
    .setListLabels("Имя", "%/id%")
    .setSearchParams(paramsHelper.search()
      .addStringParam("id"));

  document: IDocument;

  constructor(private busService: BusService) { }


  ngOnInit() {
    this.busService.onDocumentUpdated
      .subscribe(
        e => this.updateDocument(e.document));
  }


  private updateDocument(document: IDocument) {
    this.document = document;
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/pages/consts-page/consts-page.component.ts